import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "sign-in",
    component: () => import("@/views/sign-in/sign-in.vue"),
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: () => import("@/views/sign-up/sign-up.vue"),
  },
  {
    path: "/recovery",
    name: "recovery",
    component: () => import("@/views/recovery/recovery.vue"),
  },
  {
    path: "/recovery-link/:document/:id",
    name: "recovery-link",
    component: () => import("@/views/recovery-link/recovery-link.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/home.vue"),
    redirect: "/withholding-tax",
    children: [
      {
        path: "/withholding-tax",
        name: "withholding-tax",
        component: () => import("@/views/withholding-tax/withholding-tax.vue"),
      },
      {
        path: "/withholding-ica",
        name: "withholding-ica",
        component: () => import("@/views/withholding-ica/withholding-ica.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
